module.exports = __webpack_public_path__ + "img/bg_avatar_female_46.1f30adfc.png";